module.exports = __webpack_public_path__ + "img/premier-enroll-logo.18eacaab.png";